<template>
    <svg
        id="Link"
        xmlns="http://www.w3.org/2000/svg"
        width="16.6"
        height="16.5"
        viewBox="0 0 16.6 16.5"
    >
        <path
            id="Pfad_429"
            data-name="Pfad 429"
            d="M15.3,16.5H1.3A1.324,1.324,0,0,1,0,15.2V1.2A1.309,1.309,0,0,1,1.3,0H4.8a.789.789,0,0,1,.8.8.709.709,0,0,1-.8.7H1.5V15H15V11.7a.789.789,0,0,1,.8-.8.736.736,0,0,1,.8.8v3.5A1.483,1.483,0,0,1,15.3,16.5Z"
            :class="fillClass + ' transition-fill'"
        />
        <g id="Gruppe_288" data-name="Gruppe 288">
            <path
                id="Pfad_430"
                data-name="Pfad 430"
                d="M8.1,9.1a1.689,1.689,0,0,1-.5-.2.785.785,0,0,1,0-1.1l5.7-5.7a.778.778,0,0,1,1.1,1.1L8.7,8.9A1.421,1.421,0,0,1,8.1,9.1Z"
                :class="fillClass + ' transition-fill'"
            />
            <g id="Gruppe_287" data-name="Gruppe 287">
                <path
                    id="Pfad_431"
                    data-name="Pfad 431"
                    d="M15.5,5.7,10.8,1a.539.539,0,0,1,.4-.9h4.7a.472.472,0,0,1,.5.5V5.3C16.4,5.8,15.8,6.1,15.5,5.7Z"
                    :class="fillClass + ' transition-fill'"
                />
            </g>
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "LinkedIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
            default: "fill-white",
        },
    },
});
</script>
